var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagEuropeanUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 6.27173L16.5181 7.86604H18.1944L16.8382 8.85135L17.3563 10.4457L16.0001 9.46029L14.6438 10.4457L15.1619 8.85135L13.8057 7.86604H15.482L16.0001 6.27173Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11384 9.1242L10.6076 9.8852L11.7929 8.69995L11.5306 10.3556L13.0243 11.1166L11.3686 11.3789L11.1063 13.0346L10.3453 11.541L8.68965 11.8033L9.87496 10.618L9.11384 9.1242Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26094 16.0108L7.85525 15.4927V13.8164L8.8405 15.1727L10.4349 14.6546L9.44944 16.0108L10.4349 17.367L8.8405 16.849L7.85525 18.2052V16.5288L6.26094 16.0108Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11384 22.8974L9.8749 21.4037L8.68965 20.2184L10.3453 20.4807L11.1063 18.9871L11.3686 20.6427L13.0242 20.905L11.5307 21.6661L11.7929 23.3217L10.6076 22.1364L9.11384 22.8974Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 25.75L15.4819 24.1557H13.8057L15.1619 23.1704L14.6438 21.5762L16.0001 22.5614L17.3563 21.5762L16.8382 23.1704L18.1944 24.1557H16.5181L16.0001 25.75Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8871 22.8974L21.3934 22.1364L20.208 23.3217L20.4703 21.666L18.9768 20.905L20.6324 20.6427L20.8946 18.9871L21.6556 20.4807L23.3113 20.2184L22.1259 21.4038L22.8871 22.8974Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7394 16.0108L24.1451 16.5288V18.2052L23.1598 16.8489L21.5656 17.367L22.5509 16.0108L21.5656 14.6546L23.1599 15.1727L24.1451 13.8164V15.4928L25.7394 16.0108Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8871 9.12414L22.126 10.6179L23.3113 11.8032L21.6556 11.5408L20.8946 13.0345L20.6324 11.3788L18.9768 11.1165L20.4703 10.3555L20.208 8.69995L21.3934 9.8852L22.8871 9.12414Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEuropeanUnion);
export default __webpack_public_path__ + "static/media/flag_european_union.944a217777bf658d189dba7fee12d3eb.svg";
export { ForwardRef as ReactComponent };